@if (showNavBar) {
  <div class="header-navigation-back">
    <mat-icon (click)="onNavigateBack()">arrow_back</mat-icon>
    <span class="title">Shipment Contacts</span>
  </div>
}
<div >{{ errorMessage }}</div>
<app-shipment-contact-details [shipment]="shipment"> </app-shipment-contact-details>
